var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoomchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.22205 18H19.1109C21.0746 18 22.6665 16.4081 22.6665 14.4444V12C22.6665 10.8954 21.7711 10 20.6665 10C19.5619 10 18.6665 10.8954 18.6665 12V13.2C18.6665 13.6418 18.3083 14 17.8665 14H7.4665C7.02467 14 6.6665 13.6418 6.6665 13.2V12C6.6665 10.8954 5.77107 10 4.6665 10C3.56193 10 2.6665 10.8954 2.6665 12V14.4444C2.6665 16.4081 4.25837 18 6.22205 18Z",
    stroke: "#E9E9E9",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6665 10C20.6665 9.07069 20.6665 8.60603 20.5896 8.21964C20.274 6.63288 19.0336 5.39249 17.4469 5.07686C17.0605 5 16.5958 5 15.6665 5H9.6665C8.73719 5 8.27253 5 7.88614 5.07686C6.29937 5.39249 5.05898 6.63288 4.74336 8.21964C4.6665 8.60603 4.6665 9.07069 4.6665 10",
    stroke: "#E9E9E9",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6665 19V18M4.6665 19V18",
    stroke: "#E9E9E9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomchange);
export default __webpack_public_path__ + "static/media/roomchange.0545486d975b7ce801ba0bdf5c1f03a4.svg";
export { ForwardRef as ReactComponent };